import { noop } from '../../utils';
import { AddToCartContextModel } from './addtocart-data.model';

export const initialCartData: AddToCartContextModel = {
  priceInfo: {
    Ventana: '',
    Instalacion: '',
  },
  totalPrice: '',
  productCode: 'Código 1234-56', // TODO: ADD Codigo text in UI
  productTitle: '',
  brandName: '',
  images: [],
  serviceSkuId: '',
  setAddToCartData: noop,
  resetAddToCartState: noop,
};
